import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from './core/http/settings.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  title = 'everightFront';
  data = null;
  run = false;

  constructor(public router: Router, public setting: SettingsService) { }


  ngOnInit(): void {

    
  }
}
